export class ReviewAttachment {
  id?: number;
  assetId: number;
  assetName?: string;
  CreatedAt?: string | Date;
  UpdatedAt?: string | Date;
  CreatedBy?: number;
}

export class ChallengeChoice {
  id?: number;
  title?: string;
  isCorrectAnswer?: boolean;
  order?: number;
  taskId?: number;
  referenceChoiceId?: number;
  isSelected?: boolean;
}

export class ChallengeActivity {
  id?: number;
  checkListId?: number;
  title: string;
  score: number;
  taskAction: number;
  scoringMethod: number;
  url: string;
  reviewAttachmentId?: number;
  referenceTaskId?: number;
  questionTitle?: string;
  isSelected?: boolean;
  isDeleted?: boolean;
  isNewlyCreated?: boolean;
  reviewAttachment?: ReviewAttachment;
  challengeChoices?: ChallengeChoice[];
  attachedFile?: File;
  fileName?: string;
  challengeId?: number;
  completedPercentage?: number;
  completedTask?: boolean;
  pointsEarned?: number;
  isCompleted?: boolean;
  challengeTaskParticipantId?: number;
  submissionDate?: string;
  isScored?: boolean;
  unreadMessageCount?: number;
  enableManagerGuidance?: boolean;
  enableRepGuidance?: boolean;
  managerScoringGuidance: string;
  repScoringGuidance: string;
  enableScoringGuidance?: boolean;
  isChatInitiated?: boolean;
  order?: number;
  isHide?: boolean;
  enableRedo?: boolean;
  enableAllowRedo?: boolean;
}

export class ChallengeSection {
  id?: number;
  challengeId?: number;
  challengeTemplateId: number;
  title?: string;
  order?: number;
  referenceChecklistId?: number;
  challengeTasks?: ChallengeActivity[];
  isSelected?: boolean;
  isChallengeShown?: boolean;
  isChallengeMessage?: string;
}

export class ChallengeOrder {
  challengeId: number;
  profileId: number;
  order: number;
}

export class ChallengeReoder {
  profileId: number;
  challengeOrders: ChallengeOrder[];
}

export class ChallengeParticipant {
  id: number;
  participantId: number;
  managerId: number;
  email: string;
  profileType: number;
  profileLevel: number;
  profileAssetId: number;
  userRole: string;
  firstName: string;
  lastName: string;
  averageScore: number;
  isAlreadyAssigned: boolean;
  pointsEarned: number;
  unScoredTasks: number;
}

export class Challenge {
  id?: number;
  title: string;
  orderBy: number;
  isActive: boolean;
  hexCode: string;
  companyId?: number;
  adminId?: number;
  managerId?: number;
  createdBy?: number;
  creatorName?: string;
  challengeChecklists?: ChallengeSection[];
  isSelected?: boolean;
  isEdit?: boolean;
  isDeleted?: boolean;
  isNewlyCreated?: boolean;
  isGlobalTemplate?: boolean;
  copiedFromTemplateId?: number;
  templateId?: number;
  totalScore?: number;
  status?: number;
  challengeId?: number;
  checkListWithTasks?: ChallengeSection[];
  isChallengeFinalized?: boolean;
  isPublic?: boolean;
  enableScoringGuidance?: boolean;
  participantCount?: number;
  isAdminChallenge?: boolean;
  completedPercentage?: number;
  startDate?: string;
  endDate?: string;
  allowedLateSubmission?: boolean;
  isAllowedRedo?: boolean;
  operation?: string;
  addParticipant?: boolean;
  draft?: number;
  participants?: ChallengeParticipant[];
  managerFirstName?: string;
  managerLastName?: string;
  createdAt?: Date;
  isTemplateEdit?: boolean;
  isEnableFinalize?: boolean;
  isAdminChallengeFinalized?: boolean;
  isDotVisible?: boolean;
  referenceChallengeId?: number;
  state?: boolean;
  isGlobalLeaderboard?: boolean;
  assetId?: number;
  bannerImageName?: string;
  isViewOnlyChallenge?: boolean;
}

export class ChallengeRep {
  id?: number;
  managerId?: number;
  email?: string;
  profileType?: number;
  profileLevel?: number;
  profileAssetId?: number;
  userRole?: string;
  firstName?: string;
  lastName?: string;
  averageScore?: number;
  isAlreadyAssigned?: boolean;
}

export class ChallengeSetting {
  id: number;
  startDate: string;
  endDate: string;
  challengeStatus: number;
  isPublic: boolean;
  allowLateSubmission: boolean;
  enableScoringGuidance: boolean;
  challengeId: number;
  adminId: number;
  companyId?: number;
  assetId?: number;
  bannerImageName?: string;
  allowRedo: boolean;
}

export class FeedbackConversation {
  id?: number;
  challengeTaskParticipantId?: number;
  messageText?: string;
  messageType?: number;
  senderId?: number;
  receiverId?: number;
  attachmentId?: number;
  linkInfoId?: number;
  isReadBySender?: boolean;
  isReadByReceiver?: boolean;
  isRemovedBySender?: boolean;
  isRemovedByReceiver?: boolean;
  createdAt?: string;
  lastUpdatedAt?: string;
  createdUtcMillis?: number;
  utcCreatedAt?: string;
  firstName?: string;
  lastName?: string;
  profileAssetId?: number;
  taskTitle?: string;
  challengeTitle?: string;
  hexCode?: string;
  challengeId?: number;
  unreadMessageCount?: number;
  isArchivedByManager?: boolean;
  isArchivedByParticipant?: boolean;
  challengeStatus?: number;
  isActive?: boolean;
  profileId?: number;
  timeStamp?: number;
  isDisplay?: boolean;
  isHideSubmit?: boolean;
}

export class ChatConveration {
  senderFirstName: string;
  senderLastName: string;
  senderProfileAssetId: number;
  receiverFirstName: string;
  receiverLastName: string;
  receiverProfileAssetId: number;
  id: number;
  challengeTaskParticipantId: number;
  messageText: string;
  messageType: number;
  senderId: number;
  receiverId: number;
  attachmentId: number;
  linkInfoId: number;
  isReadBySender: boolean;
  isReadByReceiver: boolean;
  isRemovedBySender: boolean;
  isRemovedByReceiver: boolean;
  createdAt: string;
  lastUpdatedAt: string;
  createdUtcMillis: number;
  utcCreatedAt: string;
  assetName: string;
  linkFavIcon: string;
  linkTitle: string;
  timeStamp: number;
  assetType?: number;
}

export class AddChatModel {
  senderId: number;
  messageText: string;
  challengeTaskParticipantId: number;
  timestamp: number;
  attachmentId?: number;
}

export class RepResponse {
  id?: number;
  taskId: number;
  challengeId: number;
  participantId: number;
  textResponse?: string;
  urlChecked?: boolean;
  attachmentReviewed?: boolean;
  answerId?: number;
  audioResponseId?: number;
  videoResponseId?: number;
  uploadAttachmentResponseId?: number;
  audioBlock?: {
    id?: number;
    assetId: number
  };
  videoBlock?: {
    id?: number;
    assetId: number
  };
  attachmentBlock?: {
    id?: number;
    assetId: number
  };
}

export class ChallengeTaskParticipant {
  id: number;
  taskId: number;
  challengeId: number;
  participantId: number;
  textResponse: string;
  urlChecked: boolean;
  attachmentReviewed: boolean;
  managerResponse: number;
  managerResponseDate: Date | string;
  pointsEarned: number;
  isArchivedByManager: boolean;
  isArchivedByParticipant: boolean;
  audioResponseId: number;
  videoResponseId: number;
  uploadAttachmentResponseId: number;
  answerId: number;
  challengeTask: ChallengeActivity;
  audioBlock?: {
    id?: number;
    assetId: number
  };
  videoBlock?: {
    id?: number;
    assetId: number
  };
  attachmentBlock?: {
    id?: number;
    assetId: number
  };
  assetName: string;
}

export class ClearRepResponse {
  challengeTaskParticipantId: number;
  challengeId: number;
}

export class CoachingAsset {
  contentType: string;
  createdAt: string;
  createdBy: string;
  description: string;
  fileSize: number;
  fileType: string;
  id: number;
  isDeleted: boolean;
  isVideoFile: boolean;
  lastUpdatedAt: string;
  mediaType: number;
  name: string;
  isFileAttachement: boolean;
}

export class ChallengeBlock {
  id: number;
  buttonText: string;
  challengeId: number;
  onlineAssetId: number;
  onlineAsset: any;
}

export class MarkResponse {
  challengeId?: number;
  taskId?: number;
  participantId?: number;
  score?: number;
  promotedContent?: ChallengeFeaturedContent;
  feedbacks?: FeedbackConversation[];
  managerId?: number;
  feedbackText?: string;
  adminId?: number;
}

export class ChallengeFeaturedContent {
  id?: number;
  challengeTaskParticipantId: number;
  contentTitle: string;
  startDate: Date | string;
  endDate?: Date | string;
  managerId?: number;
  orderBy?: number;
  thumbAssetId?: number;
  adminId?: number;
  featuredTeams?: AdminPromotedContentTeam[];
  taskTitle?: string;
  taskAction?: number;
  firstName?: string;
  lastName?: string;
  managerFirstName?: string;
  managerLastName?: string;
  profileAssetId?: number;
  videoAssetId?: number;
  audioAssetId?: number;
  attachmentAssetId?: number;
  uploadAttachmentAssetId?: number;
  challengeId?: number;
  challengeTitle?: string;
  hexCode?: string;
  isExpired?: true;
  totalRecords?: number;
  textResponse?: string;
  url?: string;
  assetName?: string;
  promotedBy?: string;
  isScored?: true;
  score?: number;
  pointsEarned?: number;
  questionTitle?: string;
  answerId?: number;
  taskId?: number;
  challengeChoices?: ChallengeChoice[];
  participantId?: number;
}

export class AdminPromotedContentTeam {
  id?: number;
  promotedContentId: number;
  managerId: number;
}

export class FeaturedContentPreviewTile {
  id?: number;
  assetId: number;
  isSelected?: boolean;
  assetUrl?: string;
}

export class CurrentUserInfo {
  role: string;
  getChallengeUri: string;
  getLeaderboardUri: string;

}

export class CoachingLeaderBoard {
  assignedBy: number;
  challengeId: number;
  challengeScore: number;
  firstName: string;
  id: number;
  lastName: string;
  managerId: number;
  participantRank: number;
  profileAssetId: number;
  totalPoints: number;
}

export class LeaderBoardManager {
  email: string;
  firstName: string;
  id: number;
  isManagerAssigned: boolean;
  isParticipantAssigned: boolean;
  lastName: string;
  managerId: number;
  profileAssetId: number;
  profileType: number;
  repCount: number;
}

export class ChangeScore {
  challengeTaskParticipantId: number;
  score: number;
  managerId: number;
  challengeId: number;
}

export class ChallengeResponse {
  companyId: number;
  profileId: number;
  pageNo: number;
  pageSize: number;
  sortBy: string;
  sortOrder: string;
  searchTerm: string;
  profilesOperator: number;
  profiles: number[];
  isSalesManager: boolean;
  managers: number[];
  managersLogicalFilter: number;
  challenges: number[];
  challengeLogicalFilter: number;
  contentTypes: number[];
  contentTypeFilter: number;
}

export class ManagerChallengeResponse {
  companyId: number;
  managerId: number;
  pageNo: number;
  pageSize: number;
  sortBy: string;
  sortOrder: string;
  searchTerm: string;
  profilesOperator: number;
  profiles: number[];
  challenges: number[];
  challengeLogicalFilter: number;
  contentTypes: number[];
  contentTypeFilter: number;
  team: number[];
  viewManagerOperator: number;
  viewManagers: number[];
  allViewOnlyManagers: number[];
}

export class ChallengeResponseData {
  adminId: number;
  answerId: number;
  assetName: string;
  attachmentAssetId: number;
  audioAssetId: number;
  challengeChoices: ChallengeChoice[];
  challengeId: number;
  challengeTaskParticipantId: number;
  challengeTitle: string;
  contentTitle: string;
  endDate: string;
  firstName: string;
  hexCode: string;
  id: number;
  isExpired: boolean;
  isScored: boolean;
  lastName: string;
  managerFirstName: string;
  managerId: number;
  managerLastName: string;
  orderBy: number;
  pointsEarned: number;
  profileAssetId: number;
  questionTitle: string;
  score: number;
  startDate: string;
  taskAction: number;
  taskId: number;
  taskTitle: string;
  textResponse: string;
  thumbAssetId: number;
  totalRecords: number;
  uploadAttachmentAssetId: number;
  url: string;
  videoAssetId: number;
  scoreStatusName: string;
  taskActionName: string;
}

export class OpenActivity {
  challengeEndDate: string;
  challengeId: number;
  challengeTitle: string;
  checkListId: number;
  hexCode: string;
  reviewAttachmentId: number;
  score: number;
  taskAction: number;
  taskId: number;
  title: string;
  url: string;
}
